"use strict";

var NumberPicker = require("app/shared/components/NumberPicker/number-picker");
var BoldText = require("app/shared/components/BoldText/bold-text");

var PlanCardProUsersCapacity = React.createClass({
  mixins: [ReactIntl.IntlMixin],

  render: function() {
    var usersCapacityMessage = this.getIntlMessage("pricing.users_capacity.pro");
    var minTooltipText = this.props.showTooltip
      ? this.getIntlMessage("pricing.users_capacity.min_pro")
      : "";

    return (
      <div>
        <div className="fs-17 mt-30 planCard-darkBlue-color">
          <BoldText text={usersCapacityMessage} />
        </div>
        <div className="mt-30">
          <NumberPicker
            selectedValue={this.props.usersNumber}
            maxValue={100}
            minValue={1}
            handlePick={this.props.onUserPick}
          />
        </div>
      </div>
    );
  }
});

module.exports = PlanCardProUsersCapacity;



// WEBPACK FOOTER //
// ./app/screens/Pricing/components/PlanSelector/plan-card-pro-users-capacity.jsx